var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKybCheckActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.5 7.63656V2.125C1.5 1.92609 1.57902 1.73532 1.71967 1.59467C1.86032 1.45402 2.05109 1.375 2.25 1.375H17.25C17.4489 1.375 17.6397 1.45402 17.7803 1.59467C17.921 1.73532 18 1.92609 18 2.125V7.63469C18 15.5266 11.3147 18.1413 9.98063 18.5847C9.8312 18.6363 9.6688 18.6363 9.51937 18.5847C8.18531 18.1431 1.5 15.5312 1.5 7.63656Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.63656V2.125C1.5 1.92609 1.57902 1.73532 1.71967 1.59467C1.86032 1.45402 2.05109 1.375 2.25 1.375H17.25C17.4489 1.375 17.6397 1.45402 17.7803 1.59467C17.921 1.73532 18 1.92609 18 2.125V7.63469C18 15.5266 11.3147 18.1413 9.98063 18.5847C9.8312 18.6363 9.6688 18.6363 9.51938 18.5847C8.18531 18.1431 1.5 15.5312 1.5 7.63656Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.625L8.25 11.875L13.5 6.625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKybCheckActive);
export default __webpack_public_path__ + "static/media/KybCheckActive.5ef4384267730be49513f2efa5058ab1.svg";
export { ForwardRef as ReactComponent };